__turbopack_context__.v({
  "banner": "team-plan-sale-banner-module-scss-module__SKdwjW__banner",
  "billed-annually": "team-plan-sale-banner-module-scss-module__SKdwjW__billed-annually",
  "billed-annually-desktop": "team-plan-sale-banner-module-scss-module__SKdwjW__billed-annually-desktop",
  "billed-annually-mobile": "team-plan-sale-banner-module-scss-module__SKdwjW__billed-annually-mobile",
  "content": "team-plan-sale-banner-module-scss-module__SKdwjW__content",
  "copy": "team-plan-sale-banner-module-scss-module__SKdwjW__copy",
  "discounted-price": "team-plan-sale-banner-module-scss-module__SKdwjW__discounted-price",
  "graphic": "team-plan-sale-banner-module-scss-module__SKdwjW__graphic",
  "headline": "team-plan-sale-banner-module-scss-module__SKdwjW__headline",
  "headline-lead": "team-plan-sale-banner-module-scss-module__SKdwjW__headline-lead",
  "icon": "team-plan-sale-banner-module-scss-module__SKdwjW__icon",
  "original-price": "team-plan-sale-banner-module-scss-module__SKdwjW__original-price",
  "price": "team-plan-sale-banner-module-scss-module__SKdwjW__price",
  "price-unit": "team-plan-sale-banner-module-scss-module__SKdwjW__price-unit",
  "price-values": "team-plan-sale-banner-module-scss-module__SKdwjW__price-values",
  "subheadline": "team-plan-sale-banner-module-scss-module__SKdwjW__subheadline",
});
